import {
    getAccount,
    listAccounts
} from './queries';
import {
    createAccount,
    updateAccount,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    Account,
    CreateAccount,
    GetAccount,
    ListAccounts,
    SuspendAccount,
    UpdateAccount
} from "../types.ts";
import {
    notifyError,
    notifySuccess
} from "../../../../components/PlatformNotification";
import {generateClient} from "aws-amplify/api";
import {suspendAccount} from "./mutations.ts";
import {
    showErrorNotifications,
    showSuccessNotification
} from "../../../../components/ServiceNotifications.tsx";

// import {
//     notifyError,
//     notifySuccess
// } from "@flexinet/ui-components";


const client = generateClient();

const normalizeFilter = (filter: { [key: string]: string }) => {
    return Object.keys(filter)
                 .reduce((acc: { [key: string]: object }, key: string) => {
                     if (filter[key] !== '') {
                         acc[key] = {eq: filter[key]};
                     }
                     return acc;
                 }, {});

};

export const fetchRecords = async (filter?: { [key: string]: string }) => {

    // filter looks like this - {organizationId: 'xxxxx', email: 'XXXXXXXXXXXXX'}

    let transformedFilter = {};
    if (typeof filter !== 'undefined') {
        transformedFilter = normalizeFilter(filter);
    }

    // after normalization filter looks like this - {organizationId: {eq: 'xxxxx'}, email: {eq: 'XXXXXXXXXXXXX'}}

    try {
        const response = await client.graphql<GraphQLQuery<ListAccounts>>({
                                                                              query: listAccounts,
                                                                              variables: {filter: transformedFilter},
                                                                          });
        return response.data?.listAccounts;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetAccount>>({
                                                                            query: getAccount,
                                                                            variables: {id: id},
                                                                        });
        return response.data?.getAccount;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const add = async (payload: object) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreateAccount>>({
                                                                               query: createAccount,
                                                                               variables: {input: payload},
                                                                           });
        notifySuccess();
        return response.data?.createAccount;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const update = async (id: string, record: Account) => {


    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;


    try {
        const response = await client.graphql<GraphQLQuery<UpdateAccount>>({
                                                                               query: (updateAccount),
                                                                               variables: {input: record},
                                                                           });

        notifySuccess('Account updated');
        return response.data?.updateAccount;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};


export const suspendRecord = async () => {
    try {
        const response = await client.graphql<GraphQLQuery<SuspendAccount>>({
                                                                                query: (suspendAccount),
                                                                                variables: {},
                                                                            });
        console.debug('suspend account response', response);
        showSuccessNotification();
        return response.data?.suspendAccount;
    } catch (e) {
        showErrorNotifications(e)
    }
};

export const updateAccountCustomerId = async (accountId: string, customerId: string) => {
    try {
        // First fetch the current account to get required fields
        const currentAccount = await fetch(accountId);
        if (!currentAccount) {
            throw new Error('Account not found');
        }
        
        const response = await client.graphql<GraphQLQuery<UpdateAccount>>({
            query: updateAccount,
            variables: {
                input: {
                    id: accountId,
                    accountType: currentAccount.accountType,
                    accountStatus: currentAccount.accountStatus || 'ACTIVE',
                    customerId: customerId
                }
            }
        });
        console.log('Account updated with customer ID:', response.data?.updateAccount);
        return response.data?.updateAccount;
    } catch (e) {
        console.error('Failed to update account with customer ID:', e);
        throw e;
    }
};
